import { gql } from "@apollo/client";

export default gql`
  mutation askAiCreateOrUpdateSkill(
    $id: UUID
    $name: String!
    $description: String!
    $body: String!
    $organizationId: Int
    $forkFromSlug: String
  ) {
    createOrUpdateSkill(
      id: $id
      name: $name
      description: $description
      body: $body
      organizationId: $organizationId
      forkFromSlug: $forkFromSlug
    ) {
      skill {
        id
        name
        slug
        description
        body
        updated
      }
    }
  }
`;
